import CLIENT from '../utils/restClient';
import CUP from '../utils/CUP';
import IAM_USERS_CONTROLLER from './iamUsers';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../utils/logger';
import { FileValidationHelper } from '../utils/helpers';

export const MODULE_NAME = 'COMPANIES_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
    return MODULE_NAME+'.'+name;
}

const LOAD_SUMMARY = namespaced('LOAD_SUMMARY');
const LOAD_SUMMARY_OK = namespaced('LOAD_SUMMARY_OK');
const LOAD_SUMMARY_FAIL = namespaced('LOAD_SUMMARY_FAIL');
const LOAD_COMPANY_DETAILS = namespaced('LOAD_COMPANY_DETAILS');
const LOAD_COMPANY_DETAILS_OK = namespaced('LOAD_COMPANY_DETAILS_OK');
const LOAD_COMPANY_DETAILS_FAIL = namespaced('LOAD_COMPANY_DETAILS_FAIL');
// For now we are overloading the use of UPDATE to include delete too.
const UPDATE = namespaced('UPDATE');
const UPDATE_PROGRESS = namespaced('UPDATE_PROGRESS');
const UPDATE_OK = namespaced('UPDATE_OK');
const UPDATE_FAIL = namespaced('UPDATE_FAIL');
const EXPORT = namespaced('EXPORT');    
const EXPORT_OK = namespaced('EXPORT_OK');
const EXPORT_FAIL = namespaced('EXPORT_FAIL');

const IMPORT_COMPANIES = namespaced('IMPORT_COMPANIES');
const IMPORT_COMPANIES_OK = namespaced('IMPORT_COMPANIES_OK');
const IMPORT_COMPANIES_FAIL = namespaced('IMPORT_COMPANIES_FAIL');
const SII_CERTIFICATE_SAVE = namespaced('SII_CERTIFICATE_SAVE');
const SII_CERTIFICATE_SAVE_SUCCESS = namespaced('SII_CERTIFICATE_SAVE_SUCCESS');
const SII_CERTIFICATE_SAVE_FAIL = namespaced('SII_CERTIFICATE_SAVE_FAIL');
const LOAD_VATNUMBER_CHECK = namespaced('LOAD_VATNUMBER_CHECK');
const LOAD_VATNUMBER_CHECK_OK = namespaced('LOAD_VATNUMBER_CHECKY_OK');
const LOAD_VATNUMBER_CHECK_FAIL = namespaced('LOAD_VATNUMBER_CHECK_FAIL');
const LOAD_ITALY_LOOKUPS = namespaced('LOAD_ITALY_LOOKUPS');
const LOAD_ITALY_LOOKUPS_OK = namespaced('LOAD_ITALY_LOOKUPS_OK');
const LOAD_ITALY_LOOKUPS_FAIL = namespaced('LOAD_ITALY_LOOKUPS_FAIL');
const LOAD_CONTACT_PERSON_USERS = namespaced('LOAD_CONTACT_PERSON_USERS');
const LOAD_CONTACT_PERSON_USERS_OK = namespaced('LOAD_CONTACT_PERSON_USERS_OK');
const LOAD_CONTACT_PERSON_USERS_FAIL = namespaced('LOAD_CONTACT_PERSON_USERS_FAIL');

export const ACTION_TYPES = {
    LOAD_SUMMARY,
    LOAD_SUMMARY_OK,
    LOAD_SUMMARY_FAIL,
    LOAD_COMPANY_DETAILS,
    LOAD_COMPANY_DETAILS_OK,
    LOAD_COMPANY_DETAILS_FAIL,
    UPDATE,
    UPDATE_PROGRESS,
    UPDATE_OK,
    UPDATE_FAIL,
    IMPORT_COMPANIES,
    IMPORT_COMPANIES_OK,
    IMPORT_COMPANIES_FAIL,
    EXPORT,    
    EXPORT_OK,
    EXPORT_FAIL,
    SII_CERTIFICATE_SAVE,
    SII_CERTIFICATE_SAVE_SUCCESS,
    SII_CERTIFICATE_SAVE_FAIL,
    LOAD_VATNUMBER_CHECK,
    LOAD_VATNUMBER_CHECK_OK,
    LOAD_VATNUMBER_CHECK_FAIL,
    LOAD_ITALY_LOOKUPS,
    LOAD_ITALY_LOOKUPS_OK,
    LOAD_ITALY_LOOKUPS_FAIL,
    LOAD_CONTACT_PERSON_USERS,
    LOAD_CONTACT_PERSON_USERS_OK,
    LOAD_CONTACT_PERSON_USERS_FAIL
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('updateSubStateFromAction: ', action, state );
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD_SUMMARY:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_SUMMARY_OK:
                return Object.assign({}, state, {data: action.response, loading: false, error: null});
            case LOAD_SUMMARY_FAIL:
                return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
            case LOAD_COMPANY_DETAILS:                
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_COMPANY_DETAILS_OK:
                if(action.response) {
                    if(!state.companiesDetails) {
                        state.companiesDetails = new Map();
                    }
                    state.companiesDetails.set(`${action.response.id}`, action.response);
                }
                state.loading = false;
                state.error = null;
                return  Object.assign({}, state);
            case LOAD_COMPANY_DETAILS_FAIL:
                return Object.assign({}, state, {loading: false, error: action.error});
            case UPDATE:
                return  Object.assign({}, state, {loading: true, error: null, progress: action.progress});
            case UPDATE_PROGRESS:
                return  Object.assign({}, state, {error: null, progress: action.progress});
            case UPDATE_OK:
                return Object.assign({}, state, {loading: false, error: null});
            case UPDATE_FAIL:
                return Object.assign({}, state, {loading: false, failures: action.failures});
            
            case EXPORT:
                return  Object.assign({}, state, {loading: true, error: null});
            case EXPORT_OK:
                return Object.assign({}, state, {exportCompaniesData: action.response, loading: false, error: null});
            case EXPORT_FAIL:
                return Object.assign({}, state, {loading: false, failures: action.failures});

            case IMPORT_COMPANIES:
                return Object.assign({}, state, {loading: true, error: null});
            case IMPORT_COMPANIES_OK:
                return Object.assign({}, state, {loading: false, error: null});
            case IMPORT_COMPANIES_FAIL:
                return Object.assign({}, state, {loading: false, error: action.error});
            case SII_CERTIFICATE_SAVE:
                    return Object.assign({}, state, {loading: true,saveCertificate:null,saveCertificateError:null});
            case SII_CERTIFICATE_SAVE_SUCCESS:
                return Object.assign({}, state, {saveCertificate : true,loading: false,saveCertificateError:null});
            case SII_CERTIFICATE_SAVE_FAIL:
                return Object.assign({}, state, {saveCertificate : false,loading: false, saveCertificateError: action.error});
            case LOAD_VATNUMBER_CHECK:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_VATNUMBER_CHECK_OK:
                return Object.assign({}, state, {vatNumberCheck: action.response, loading: false, error: null});
            case LOAD_VATNUMBER_CHECK_FAIL:
                return Object.assign({}, state, {vatNumberCheck: undefined, loading: false, error: action.error});
            case LOAD_ITALY_LOOKUPS:
                return Object.assign({}, state, {loading: true, error: null});
            case LOAD_ITALY_LOOKUPS_OK:
                return Object.assign({}, state, {
                    activityCodesIT: action.response.activityCodes, 
                    companyTypesIT: action.response.companyTypes, 
                    loading: false, 
                    error: null
                });
            case LOAD_ITALY_LOOKUPS_FAIL:
                return Object.assign({}, state, {loading: false, error: action.error});
            case LOAD_CONTACT_PERSON_USERS:
                return Object.assign({}, state, { contactPersonUsersError: null });
            case LOAD_CONTACT_PERSON_USERS_OK:
                return Object.assign({}, state, {
                    contactPersonUsers: action.response,
                    contactPersonUsersError: null
                });
            case LOAD_CONTACT_PERSON_USERS_FAIL:
                return Object.assign({}, state, {
                    contactPersonUsers: undefined,
                    contactPersonUsersError: action.error
                });
            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('updateSubStateFromAction:  newState', newState );
    return newState;
};


const toContactPersonUserList = (iamUsers) =>
    (iamUsers || []).map((user) => ({ id: user.userName }));

export const API = {
doLoad: () => {},
    doLoadCompaniesSummary: () => {
        log.debug("doLoadCompaniesSummary()");
        return (dispatch, getState) => {
            dispatch({type: LOAD_SUMMARY});
            return CLIENT.getCompaniesSummaryV3()
                .then( response => {
                    dispatch({type: LOAD_SUMMARY_OK, response: response});
                })
                .catch( error => {
                    dispatch({ type: LOAD_SUMMARY_FAIL, error: error});
                });
        };        
    },
    
    doLoadCompanyDetails: (id, callback = () => { }) => {
        log.debug("doLoadCompanyDetails()");
        return (dispatch, getState) => {
            dispatch({type: LOAD_COMPANY_DETAILS});
            return CLIENT.getCompanyDetailsById(id)
                .then( response => {
                    dispatch({
                        type: LOAD_COMPANY_DETAILS_OK,
                        response: response
                    });
                    callback(null, response);
                }).catch( error => {
                    dispatch({
                        type: LOAD_COMPANY_DETAILS_FAIL,
                        error: error
                    });                    
                    callback(error, null);
                });
        };
    },

    getCompanyName: (companies, companyId) => {
        // TODO: Bit rubbish doing this every single time. Think of a better way.
        const companyArray = (companies && companies.data) || [];
        const companyDictionary = companyArray.reduce((dictionary, company) => {
            dictionary[company.id] = company;
            return dictionary;
        }, {});
        return companyDictionary[companyId] && companyDictionary[companyId].name;

    },
    doUpdate: (id, company) => {
        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            return CLIENT.updateCompany(company,id)
                .then((response) => {                    
                    dispatch({type: LOAD_COMPANY_DETAILS_OK, response: company}); // To Update the companiesDetails in redux state
                    dispatch({type: UPDATE});  
                    CLIENT.getCompaniesSummaryV3()
                            .then( response => {
                                dispatch({type: LOAD_SUMMARY_OK, response: response});
                            })           
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },
    doUpdateWithEsSIICertificate: (id, company,esSIICertificateDetails,validHandler, invalidHandler) => {
        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            return CLIENT.updateCompany(company,id)
                .then((response) => {
                    dispatch({type: SII_CERTIFICATE_SAVE});
                    CLIENT.doSaveEsSIICertificate(esSIICertificateDetails)
                        .then((response)=>{
                            dispatch({type: SII_CERTIFICATE_SAVE_SUCCESS});
                            validHandler(response);
                           //Certifiate updated successfully to database
                            dispatch({type: UPDATE});
                            dispatch({type: LOAD_COMPANY_DETAILS_OK, response: company});
                            CLIENT.getCompaniesSummaryV3()
                            .then( response => {
                                dispatch({type: LOAD_SUMMARY_OK, response: response});
                            })
                        })
                        .catch((error)=>{
                            dispatch({type: SII_CERTIFICATE_SAVE_FAIL ,error: error});
                            invalidHandler(error);
                        })
                    
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },
    doDelete: (id) => {
        // TODO: Consider adding support for deleting multiple users.
        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            return CLIENT.deleteCompany(id)
                .then((response) => {
                    dispatch({type: UPDATE_PROGRESS, response: response});
                    CLIENT.getCompaniesSummaryV3()
                    .then( response => {
                        dispatch({type: LOAD_SUMMARY_OK, response: response});
                    })
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },

    doDeleteMany: (ids=[], fetchAfterDelete=true, callback=()=>{}) => {
        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            return CLIENT.deleteManyCompanies(ids)
                .then((response) => {
                    if(fetchAfterDelete) {
                        dispatch({type: UPDATE_PROGRESS, response: response});
                        CLIENT.getCompaniesSummaryV3()
                        .then( response => {
                            dispatch({type: LOAD_SUMMARY_OK, response: response});
                        })
                    } else {
                        dispatch({type: UPDATE_OK, response: response});
                        callback(null, response);
                    }
                })
                .catch((error) => {
                    dispatch({type: UPDATE_FAIL, error});
                    callback(error, null);
                });
        }
    },
    
    doCreate: (company) => {
        return (dispatch, getState) => {
            dispatch({type: UPDATE});
            return CLIENT.createCompany(company)
                .then((response) => {
                    log.clearDictionaryError(ALL_MESSAGES.DUPLICATE_COMPANY_CODE);
                    dispatch({type: UPDATE_PROGRESS, response: response});                  
                    CLIENT.getCompaniesSummaryV3()
                    .then( response => {
                        dispatch({type: LOAD_SUMMARY_OK, response: response});
                    })
                })
                .catch((error) => {
                    if(error.status === 409) {
                        log.setDictionaryMessage(ALL_MESSAGES.DUPLICATE_COMPANY_CODE);
                    }
                    dispatch({type: UPDATE_FAIL, error});
                });
        }
    },

    doImportCompanies: (files=[], callback=()=>{})  => {
        log.debug('doImportCompanies(): ', files, callback);
        log.clearDictionaryError(ALL_MESSAGES.COMPANIES_IMPORTED_SUCCESSFULLY); 
        log.clearDictionaryError(ALL_MESSAGES.VIRUS_SCAN_FAILED);
        log.clearDictionaryError(ALL_MESSAGES.COMPANIES_IMPORT_FAILED);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH);
        return (dispatch, getState) => {
            dispatch({type: IMPORT_COMPANIES});
            return CLIENT.importCompanies(files)
            .then((response) => {
                log.debug('doImportCompanies(): succeeded');
                dispatch({type: IMPORT_COMPANIES_OK, response});
                log.clearAllDictionaryErrors();
                log.setDictionaryMessage(ALL_MESSAGES.COMPANIES_IMPORTED_SUCCESSFULLY);
                callback(null, response);
            })
            .catch((error={}) => {
                switch(error.status) {
                    case 406:
                        log.setDictionaryMessage(ALL_MESSAGES.VIRUS_SCAN_FAILED);
                        break;
                    case 400:
                        error.text()
                            .then((errorMessage) => {
                                let validationMessage = FileValidationHelper.getFileValidationMessage(errorMessage);
                                if (validationMessage) {
                                    log.setDictionaryMessage(validationMessage);
                                } else {
                                    log.setDictionaryMessage(ALL_MESSAGES.COMPANIES_IMPORT_FAILED);
                                }
                            });
                        break;
                    default:
                        break;
                }   
                log.debug('doImportCompanies(): error', error );
                dispatch({type: IMPORT_COMPANIES_FAIL, error});
                callback(error, null);
          });
      };
    },
    
    doExport: (callback) => {
        return (dispatch, getState) => {
            dispatch({type: EXPORT});
            return CLIENT.exportCompanies()
                .then((response) => {
                    dispatch({type: EXPORT_OK, response: response});
                    if(typeof callback === 'function') {
                        callback(null, response);
                    }
                })
                .catch((error) => {
                    dispatch({type: EXPORT_FAIL, error});
                    if(typeof callback === 'function') {
                        callback(error, null);
                    }
                });
        }
    },

    doClearAllErrors: () => {
        log.debug('doClearAllErrors()');
        return (dispatch, getState) => {
            log.clearDictionaryError(ALL_MESSAGES.DUPLICATE_COMPANY_CODE);
        };
    },
    doValidateVATNumber: (vatnumber,callback = () => { }) => {
        log.debug('doValidateVATNumber()',callback);
        return (dispatch, getState) => {
            dispatch({type: LOAD_VATNUMBER_CHECK});
            return CLIENT.doValidateVatNumber(vatnumber)
                .then((response) => {
                    callback(response);
                    dispatch({type: LOAD_VATNUMBER_CHECK_OK, response: response});
                })
                .catch((error) => {
                    dispatch({type: LOAD_VATNUMBER_CHECK_FAIL, error});
                });
        }
    },

    doLoadItalyLookups: () => {
        log.debug('doLoadItalyLookups()');
        return (dispatch, getState) => {
            dispatch({ type: LOAD_ITALY_LOOKUPS });
            return CLIENT.getItalyLookups()
                .then(response => {
                    dispatch({ type: LOAD_ITALY_LOOKUPS_OK, response: response });
                })
                .catch(error => {
                    log.debug('doLoadItalyLookups(): error', error);
                    dispatch({ type: LOAD_ITALY_LOOKUPS_FAIL, error: error });
                });
        };
    },

    doLoadContactPersonUsers: () => {
        return async (dispatch, getState) => {
            dispatch({ type: LOAD_CONTACT_PERSON_USERS });
            const { iamData } = getState().authentication?.data || {};

            try {
                if (iamData?.isIamUser && iamData?.tenantId) {
                    const iamUsers = await dispatch(IAM_USERS_CONTROLLER.doEnsureLoaded(iamData.tenantId));
                    dispatch({
                        type: LOAD_CONTACT_PERSON_USERS_OK,
                        response: toContactPersonUserList(iamUsers),
                    });
                    return;
                }

                const response = await CUP.getUsers();
                dispatch({ type: LOAD_CONTACT_PERSON_USERS_OK, response });
            } catch (error) {
                dispatch({ type: LOAD_CONTACT_PERSON_USERS_FAIL, error });
            }
        };
    },

};

export default API;
